import { observable, action, toJS } from 'mobx';

const initState = {
  visible: false,
  appId: '',
};

export class OldApplyStore {

  routing = null;

  @observable visible = initState.visible;
  @observable appId = initState.appId;

  constructor(routing) {
    this.routing = routing;
  }

  @action
  setState = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key];
    });
    return this;
  }

  @action
  clear = () => this.setState(initState)

}


// WEBPACK FOOTER //
// ./src/stores/oldApply/index.js